var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.75 188.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n        stroke: #6da4da;\n      }\n\n      .cls-1, .cls-2, .cls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5 {\n        stroke-width: .25px;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 0 0 1.99 4.98;\n      }\n\n      .cls-3 {\n        stroke-width: .15px;\n      }\n\n      .cls-3, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        stroke-dasharray: 0 0 2 4.99;\n      }\n\n      .cls-6 {\n        fill: #6da4da;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.88,
    cy: 94.03,
    r: 76.16,
    transform: "translate(-41.63 87.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.88,
    cy: 94.03,
    r: 68.82,
    transform: "translate(-41.63 87.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 84.88,
    cy: 94.03,
    r: 84.58
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.71 75.27 74.05 75.27 63.21 94.03 74.05 112.79 95.71 112.79 106.54 94.03 95.71 75.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.4 82.72 78.35 82.72 71.82 94.03 78.35 105.34 91.4 105.34 97.93 94.03 91.4 82.72"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.88 18.99 19.89 131.55 149.86 131.55 84.88 18.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.88 169.07 149.86 56.51 19.89 56.51 84.88 169.07"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "84.88 36.34 34.92 122.87 134.84 122.87 84.88 36.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "84.88 151.72 134.84 65.18 34.92 65.18 84.88 151.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 84.88,
    cy: 47.08,
    rx: 34.03,
    ry: 46.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 44.21,
    cy: 70.55,
    rx: 34.03,
    ry: 46.95,
    transform: "translate(-38.99 73.57) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 44.21,
    cy: 117.5,
    rx: 46.95,
    ry: 34.03,
    transform: "translate(-52.83 37.85) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 84.88,
    cy: 140.98,
    rx: 34.03,
    ry: 46.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 125.54,
    cy: 117.5,
    rx: 34.03,
    ry: 46.95,
    transform: "translate(-38.99 167.47) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 125.54,
    cy: 70.55,
    rx: 46.95,
    ry: 34.03,
    transform: "translate(-18.46 72.22) rotate(-30)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.29,56.22c-.24,2.25,1.53,4.52,3.77,4.84,2.24,.32,4.57-1.36,4.98-3.59,.4-2.18-1.39-5.07-3.69-5.4-2.3-.33-4.83,1.93-5.06,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.45,93.67c-.24,2.25,1.53,4.52,3.77,4.84s4.57-1.36,4.98-3.59c.4-2.18-1.39-5.07-3.69-5.4-2.3-.33-4.83,1.93-5.06,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.15,56.22c-.24,2.25,1.53,4.52,3.77,4.84,2.24,.32,4.57-1.36,4.98-3.59,.4-2.18-1.39-5.07-3.69-5.4-2.3-.33-4.83,1.93-5.06,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.52,93.67c-.24,2.25,1.53,4.52,3.77,4.84s4.57-1.36,4.98-3.59c.4-2.18-1.39-5.07-3.69-5.4-2.3-.33-4.83,1.93-5.06,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.82,131.19c-.24,2.25,1.53,4.52,3.77,4.84s4.57-1.36,4.98-3.59c.4-2.18-1.39-5.07-3.69-5.4s-4.83,1.93-5.06,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.82,131.19c-.24,2.25,1.53,4.52,3.77,4.84s4.57-1.36,4.98-3.59c.4-2.18-1.39-5.07-3.69-5.4-2.3-.33-4.83,1.93-5.06,4.14Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.9f29528dd37a1e1c03c4d14cf49d7ac8.svg";
export { ForwardRef as ReactComponent };